import { trackRoomClicked } from '@/services/room-interactions-tracker';

import { setRoomTag } from '../../../../../modules/room-tag-storage.js';
import { init as initCountrySelectionHeader } from './location-page.country-header.js';
import { init as initDataTracking, onBeforeSlide } from './location-page.data-tracking.js';
import { init as initExperiments } from './location-page.experiments.js';
import initTrackingForFaqs from './location-page.faqs.js';
import { init as initFilters } from './location-page.filters.js';
import initTrackingForProgrammaticSections from './location-page.programatic-sections.js';
import { init as initSearchForm } from './location-page.search-form.js';
import { initMicroClusters } from './location-page-microclusters';

function initLocationPageTracking() {
  $('.js-location-page-tracking').click(function (e) {
    e.stopPropagation();

    App.track.event('clicked_to_location_page', {
      section: $(this).attr('data-section').trim(),
      element: $(this).attr('data-element').trim(),
      element_value: $(this).text().trim(),
      interaction: 'click',
    });
  });
}
if (!window.__LOCATION_PAGE_ID) {
  throw new Error('Missing __LOCATION_PAGE_ID');
}

window.$ready(() => {
  App.es6.shared.in_view();
  App.components.home_show_more();

  App.track.pageViewEvent();
  App.track.event('location_page_pageview');

  // break down long tasks to avoid blocking the main thread
  setTimeout(() => {
    $('[data-content-collapse]').each((index, element) => {
      App.es6.shared.collapseContent(element);
    });
  }, 10);

  setTimeout(() => {
    App.views.room.truncate();
  }, 40);

  // make room descriptions clickable
  $('.c-room-card__review__content').on('click', (e) => {
    $(e.target).parents('.c-room-card__review').prev('a')[0].click();
  });

  // preload next navigation scripts
  App.es6.shared.preload(['room', 'search']);

  App.es6.shared.lory_carousel(undefined, true, { lazyOffset: -500 }, { onBeforeSlide });

  App.components.room_cards_carousel();

  // open first accordion
  document.querySelector('.faq-section__content > .ds-accordion > .ds-accordion__trigger')?.click();

  initExperiments();
  initSearchForm();
  initDataTracking();
  initCountrySelectionHeader();
  initLocationPageTracking();
  initFilters();

  if (window.__TGV_ROOM_TAG) {
    setRoomTag(window.__TGV_ROOM_TAG);
  }

  const LANDING_LOCATION_PAGE_COOKIE = 'tgv_landing_location_page';
  const landingLocationPage = App.es6.shared.cookie.get(LANDING_LOCATION_PAGE_COOKIE);
  if (!landingLocationPage) {
    App.es6.shared.cookie.set(LANDING_LOCATION_PAGE_COOKIE, window.__LOCATION_PAGE_ID, 30);
  }

  // homepage (SG) / country location page
  $('.c-box-carousel-wrap--citypage-popular-rooms .c-room-card').click((e) => {
    const $target = $(e.currentTarget);
    const id = $target.data('id');
    const venueId = $target.data('venue-id');
    const index = $target.data('index');

    trackRoomClicked(+id);

    App.track.event('clicked_to_room_page', {
      section: 'homepage_popular_rooms',
      element: 'room_tile',
      element_value: id,

      room_id: id,
      venue_id: venueId,
      position: (+index + 1),

      interaction: 'click',
    });
  });

  // map/pagination tracking + redirection logic
  $('.c-hire-sidebar-button button, .p-hire-bottom-box-button button')
    .on('click', (e) => {
      e.preventDefault();

      App.track.event('clicked_to_search_page', {
        section: 'location_page_listing_top',
        element: 'cta_button',
        element_value: 'see_all_venues',
        interaction: 'click',
      });

      if (window.location.href.includes('E2E_STOP_REDIRECTION')) {
        return;
      }

      const href = $('.js-more-venues-url').attr('href');
      const searchUrl = new URL(href);
      window.location = searchUrl.href;
    });

  function onMapClick() {
    const href = $('.js-more-venues-url').attr('href');
    const searchUrl = new URL(href);
    searchUrl.searchParams.set('view', 'map');
    window.location = searchUrl.href;
  }

  $('.c-hire-pagination').click((event) => {
    App.track.event('clicked_to_search_page', {
      section: 'location_page_listing_bottom',
      element: 'fake_pagination',
      element_value: event.currentTarget.dataset.numberOfPages,
      interaction: 'click',
    });

    window.location.href = event.currentTarget.dataset.searchUrl;
  });

  $('.c-hire-map__show-map').on('click', (e) => {
    e.stopPropagation();
    e.preventDefault();

    App.track.event('clicked_to_search_page', {
      section: 'map',
      element: 'map_button',
      element_value: 'show_map',
      interaction: 'click',
    });

    onMapClick('Show_map_button');
  });

  $('.c-hire-map__label').on('click', (e) => {
    e.stopPropagation();

    App.track.event('clicked_to_search_page', {
      section: 'map',
      element: 'available_venues_map_button',
      element_value: $(e.target).text().trim(),
      interaction: 'click',
    });

    onMapClick('Available_venues_map_button');
  });

  $('.c-hire-map a').on('click', (e) => {
    e.preventDefault();

    App.track.event('clicked_to_search_page', {
      section: 'map',
      element: 'map_preview',
      interaction: 'click',
    });

    onMapClick('Map');
  });

  $('.js-show-all-additional-rooms-section').on('click', () => {
    App.track.event('clicked_to_search_page', {
      section: 'map',
      element: 'additional_rooms_section',
      interaction: 'click',
    });
  });

  // show more for crosslinking
  document.querySelectorAll('.p-hire-crosslinkings-wrap').forEach(section => {
    const showMore = section.querySelector('.js-crosslinking-show-more');

    showMore?.addEventListener('click', () => {
      section.classList.add('p-hire-crosslinkings-wrap--expanded');
    });

    const showLess = section.querySelector('.js-crosslinking-show-less');

    showLess?.addEventListener('click', () => {
      section.classList.remove('p-hire-crosslinkings-wrap--expanded');
    });
  });

  initMicroClusters();
  initTrackingForProgrammaticSections();
  initTrackingForFaqs();

  setTimeout(() => {
    fetch(window.__TGV_SEARCH_URL);
  }, 1000);
});
